import { EEventType } from './../../enums/EEventType';
import styles from './index.module.less';
import template from './index.art';
import OY from '../../types/OY';
import { IOYCheckboxProps, IOYCheckboxState } from './const';
import { valueIncludes } from '../../utils';
import { jeact } from '../../decorators/jeact';
@jeact({ autoRender: true })
export default class OYCheckbox extends OY<IOYCheckboxProps, IOYCheckboxState> {
  static displayName = 'OYCheckbox';

  static defaultProps: Partial<IOYCheckboxProps> = {
    splitIndeterminate: true,
    info: [],
    maxTextLength: 15
  }

  public state: IOYCheckboxState = {
    titleWidth: '',
    itemWidth: ''
  };

  $node = {
    titleInput: $(),
    item: $(),
    input: $()
  }

  getDerivedStateFromProps(nextProps: IOYCheckboxProps, state: IOYCheckboxState) {
    return { ...state, ...this.caclWidth(nextProps) }
  }

  render() {
    return template({ props: this.props, state: this.state, styles })
  }

  setNode(): void {
    this.$node = {
      titleInput: this.$el.find(`.${styles.oy_chekcbox_title} input`),
      item: this.$el.find(`.${styles.oy_chekcbox_item}`),
      input: this.$el.find(`.${styles.oy_chekcbox_item} input`)
    }
  }

  protected bindCheckbox() {
    // FIXED: 这里不能使用node.input 否则会有问题
    this.$el.delegate(`.${styles.oy_chekcbox_item} input`, 'change', (ev: Event) => {
      const values: string[] = [];
      const $this = $(ev.target!);

      const value = $this.parent().data('value');
      const revertChecked = !$(ev.target!).has(':checked');

      this.$node.input.each((_id, element) => {
        const $element = $(element);
        if ($element.is(':checked')) {
          values.push(`${$element.parent().data('value')}`)
        }
      })

      // 设置全选状态
      if (values.length !== this.$node.input.length) {
        this.$node.titleInput.prop({ checked: false })
      } else {
        this.$node.titleInput.prop({ checked: true })
      }

      this.emitChange(values, { [value]: revertChecked })
    })
  }

  protected bindCheckAll() {
    this.$el.delegate(`.${styles.oy_chekcbox_title}`, 'change', (ev: Event) => {
      // console.log('chnage')
      const $target = $(ev.currentTarget!);

      const $input = $target.find('input');
      const values: string[] = [];

      const revertChecked: any = {};
      if ($input.is(':checked')) {
        this.$node.input.each((_id, element) => {
          const $element = $(element);
          const value = `${$element.parent().data('value')}`;
          values.push(value);
          revertChecked[value] = $element.is(':checked')
        })
        this.$node.input.prop({ checked: true })
        this.emitChange(values, revertChecked)
      } else {
        this.$node.input.each((_id, element) => {
          const $element = $(element);
          const value = `${$element.parent().data('value')}`;
          revertChecked[value] = $element.is(':checked')
        })
        this.$node.input.prop({ checked: false })
        this.emitChange([], revertChecked)
      }
    })
    this.$el.find('[data-toggle="tooltip"]').each((_idx, ele) => {
      const $ele = $(ele);
      $ele.tooltip()
    });
  }

  private emitChange(value: string[], revertData: { [i: string]: any } = {}) {
    const { beforeChange } = this.props
    if (beforeChange) {
      const result = beforeChange(value);
      if (result) {
        this.eventEmitter.emit(EEventType.onChange, value)
      } else {
        // 执行回滚
        this.$node.input.each((_id, element) => {
          const $ele = $(element);
          const dataValue = `${$ele.parent().data('value')}`;
          if (revertData[dataValue] !== undefined) {
            $ele.prop({ checked: revertData[dataValue] });
          }
          // if (valueIncludes(this.preValue, dataValue)) {
          //   $ele.prop({ checked: true });
          // } else {
          //   $ele.prop({ checked: false });
          // }
        })

        const length = this.$node.input.filter(':checked').length;
        // 设置全选
        this.$node.titleInput.prop({ checked: value.length === length });
      }
    } else {
      this.eventEmitter.emit(EEventType.onChange, value)
    }
  }

  private caclWidth({ splitIndeterminate, cells, width }: IOYCheckboxProps) {
    let titleWidth = '';
    let itemWidth = '';
    // 计算宽高
    if (splitIndeterminate) {
      if (cells) {
        titleWidth = `${(100 / cells).toFixed(4)}%`;
        itemWidth = `${(100 / (cells - 1)).toFixed(4)}%`
      } else if (width) {
        titleWidth = `${width}px`;
        itemWidth = `${width}px`
      }
    } else {
      if (cells) {
        itemWidth = `${(100 / cells).toFixed(4)}%`
      } else if (width) {
        itemWidth = `${width}px`
      }
    }
    return { titleWidth, itemWidth }
  }
}



// WEBPACK FOOTER //
// ./src/components/OYCheckbox/index.ts